const baseCanonicalUrl = 'https://www.owndays.com/sg/en/eyewear';

export const EYE_WEARS = [
  {
    title: 'Eyeglasses',
    targetPath: '/eyewear/eyeglasses.html',
    description: `OWNDAYS provides a wide selection of eyeglasses, from transparent spectacles to rectangle frames and other stylish frameless designs to suit any face shape and personal style. Whether you're looking for classic, modern or minimalist frames, each pair ensures durability and comfort.`,
    meta: {
      title: 'Eyeglasses & Spectacle Frames | OWNDAYS ONLINE STORE - OPTICAL SHOP',
      description:
        'Shop eyeglasses, transparent spectacles, square frames and frameless designs at OWNDAYS. All come with UV protection and dust-repellent high-index lenses.',
      keywords:
        'Frames,Spectacle,Sunglasses,optical shop,eyeglasses,OWNDAYS,frame,sunglasses,eyewear Singapore,pc lenses',
      canonicalUrl: `${baseCanonicalUrl}/eyeglasses.html`,
    },
  },
  {
    title: 'Sunglasses',
    targetPath: '/eyewear/sunglasses.html',
    description: `All OWNDAYS sunglasses feature high-index aspheric lenses with 100% UV protection and a dust-repellent coating. Designed for lasting comfort and clear vision, these stylish sunglasses offer both protection and durability for everyday wear.`,
    meta: {
      title: 'Sunglasses with 100% UV Protection',
      description:
        'OWNDAYS sunglasses store features 100% UV protection and dust-repellent lenses, starting from $20. Enjoy stylish designs with clear vision & lasting comfort.',
      keywords:
        'Frames,Spectacle,Sunglasses,optical shop,eyeglasses,OWNDAYS,frame,sunglasses,eyewear Singapore,pc lenses',
      canonicalUrl: `${baseCanonicalUrl}/sunglasses.html`,
    },
  },
  {
    title: 'Accessories',
    targetPath: '/accessories.html',
    description: `All OWNDAYS spectacles and sunglasses come with high index aspheric lenses that have dust-repellent coating and offer UV protection. Find your perfect pair of eyewear in OWNDAYS.`,
    meta: {
      title: 'Accessories',
      description:
        'All OWNDAYS spectacles and sunglasses come with high index aspheric lenses that have dust-repellent coating and offer UV protection. Find your perfect pair of eyewear in OWNDAYS.',
      keywords:
        'accessories,cloth,case,cleaner,chain,pouch,frames,spectacle,sunglasses,optical shop,eyeglasses,OWNDAYS,eyewear,Singapore,pc lenses',
      canonicalUrl: `https://www.owndays.com/sg/en/accessories.html`,
    },
  },
];
